import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* ErrorLayer */}
        <ErrorLayer />


      </MasterLayout>
    </>
  );
};

export default ErrorPage;
